import React, { useState, useEffect } from "react";
import useDebounce from "../useDebounce/useDebounce";
import UserSearchDropdown from "../CustomDropdown/UserSearchDropdown";
import apiHelper from "../ApiHelpar/apiHelper";
import { SERCH_BRANCH_BY_NAME_WITH_PAGINATION } from "../visitConstant/ApiConstant";

const BranchSearchDropdown = ({
  onSelect,
  hospitalId = null,
  type = "branch",
  selectedBranchId,
}) => {
  const config = {
    displayKey: "branchName", // Adjust based on your API response
    placeholder: "Search branches",
  };

 

  const [searchTerm, setSearchTerm] = useState( selectedBranchId?.branchName||"");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const debouncedSearchTerm = useDebounce(searchTerm, 700);

  const fetchData = async () => {
    // Only search if the term is not empty
    setOptions([]);

    setLoading(true);
    setError(null);

    try {
      const response = await apiHelper(SERCH_BRANCH_BY_NAME_WITH_PAGINATION, {
        name: debouncedSearchTerm,
        hospitalId: hospitalId,
        offset: 0,
        pageSize: 10,
        activeStatus: true,
      });

      // Safely access the response data
      const searchResults = response?.respData?.respMsg.content || [];

      setOptions(searchResults);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to fetch options";
      setError(errorMessage);
      console.error("Search error:", err);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
   
    fetchData();
  }, [debouncedSearchTerm, hospitalId]);

    useEffect(() => {
      if (selectedBranchId?.branchName) {
        setSearchTerm(selectedBranchId?.branchName);
      }
    }, [selectedBranchId?.branchName]);

  const handleSelect = (selectedItem) => {
    // Ensure onSelect is called with the selected item
    onSelect(selectedItem);
    console.log(selectedItem);
    // Set the search term to the display value
    setSearchTerm(selectedItem[config.displayKey] || "");
   
  };

  return (
    <div className="search-container">
      <UserSearchDropdown
        options={options}
        handleInputChange={setSearchTerm}
        onSelect={handleSelect}
        value={searchTerm.branchName}
        loading={loading}
        Placeholder={config.placeholder}
        searchTerm={searchTerm}
        newEntry={true}
        UserSearchDrop={false}
        displayKey={(option) => option?.branchName || ""}
      />

      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default BranchSearchDropdown;
